import React from 'react'
import type { ClickablePopupColor } from './types'
import './ClickablePopup.css'

// Grid chip that opens the popup. A plain span (not a button) so the DataGrid
// keeps its own row focus and keyboard navigation.
export function ClickablePopupCell(props: {
	value: any
	label: any
	color?: ClickablePopupColor
	onClick: () => void
}): JSX.Element {
	const { value, label, color, onClick } = props
	const empty = value === null || value === undefined || value === ''

	return (
		<span
			className="clickable-popup-chip"
			title={empty ? '' : String(label)}
			style={color ? { background: color.background, color: color.color } : undefined}
			onClick={onClick}
		>
			{empty ? '—' : label}
		</span>
	)
}
